//import type { NextPage, GetServerSideProps, InferGetServerSidePropsType } from "next";
import type { NextPage, GetStaticProps, InferGetStaticPropsType } from "next";

import { CollectionData } from "data/collections";
import { getHomepageData, HomepageData } from "data/homepage";
import { ProductData } from "data/product/products";

import { getProductCollectionWithSlug } from "~/api/collectionsApi";
import { getNewReleasesProducts } from "~/api/productApi";
import { getMostPopularProducts } from "~/api/productApi";
import Browse from "~/components/browse/Browse";
import { BrowseSSGData } from "~/components/browse/types";

interface StaticProps {
  homepageData: HomepageData;
  browseData: BrowseSSGData;
}

const BrowsePage: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  homepageData,
  browseData,
}) => {
  return <Browse homepageData={homepageData} browseData={browseData} />;
};

export const getStaticProps: GetStaticProps<StaticProps> = async () => {
  const newReleases = await getNewReleasesProducts(false, 23);
  const popularProducts = await getMostPopularProducts(false, 24);
  const musicCollection: CollectionData = await getProductCollectionWithSlug("all-music");
  const popularProductsProducts: ProductData[] = popularProducts.products;
  //const newReleasesProducts: ProductData[] = [(musicCollection as ProductData), ...newReleases.products];
  const newReleasesProducts: ProductData[] = [...newReleases.products];
  const newReleasesTotalAvailableCount = newReleases.totalAvailableCount;
  return {
    props: {
      homepageData: getHomepageData(),
      browseData: {
        newReleases: newReleasesProducts,
        popularProducts: popularProductsProducts,
        newReleasesTotalAvailableCount: newReleasesTotalAvailableCount,
      },
    },
  };
};

export default BrowsePage;
